import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const LicensingWarningModal = (props) => {
    const { classes, modalState, handleCloseDanger, handleCloseSafe, translations } = props;

    const handleCloseModalYes = () => {
        handleCloseDanger(modalState.fieldName, modalState.value);
    }

    return (
        <Dialog
            open={modalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['change_licensing_setting'] || 'Change licensing setting'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['option_will_have_impact_on_users_and_groups'] || 'This option will have impact on all users and groups'}.<br/>
                    {translations['want_to_proceed'] || 'Are you sure you want to proceed'}?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseModalYes} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(LicensingWarningModal);